import React from "react";
import MyRouter from "routers/index";
import { SkeletonTheme } from "react-loading-skeleton";

function App() {
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
     <SkeletonTheme>
        <MyRouter />
      </SkeletonTheme>
    </div>
  );
}

export default App;
